import { render, staticRenderFns } from "./SituacoesEditar.vue?vue&type=template&id=49863267&scoped=true&"
import script from "./SituacoesEditar.vue?vue&type=script&lang=js&"
export * from "./SituacoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./SituacoesEditar.vue?vue&type=style&index=0&id=49863267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49863267",
  null
  
)

export default component.exports